import {
  AutoAwesome,
  AutoAwesomeOutlined,
  WavingHand,
} from "@mui/icons-material";
import { div, Typography, useTheme } from "@mui/material";
import React from "react";
import { font } from "../../../../styles/font";
import { amber } from "@mui/material/colors";
import { Trans, useTranslation } from "react-i18next";
import dayjs from "dayjs";
import ApplicationLogo from "../../../layout/ApplicationLogo";
import { AICustomIcon } from "../../../styled/CustomIcons";
import { Link } from "react-router-dom";
import { LuZap } from "react-icons/lu";

export default function LeftSection() {
  const theme = useTheme();
  const { t } = useTranslation("translation", { keyPrefix: "auth" });

  return (
    <div className="hidden lg:flex lg:w-1/2 relative bg-gradient-to-br from-background via-background to-cyan/5 p-12 flex-col justify-center items-center">
      {/* Background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan/10 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-emerald/10 rounded-full blur-3xl" />
      </div>

      <div className="relative z-10 max-w-md text-center">
        <Link
          // to="/"

          className="inline-flex items-center gap-3 mb-8 group"
        >
          <div className="relative">
            {/* <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-cyan to-emerald flex items-center justify-center shadow-lg shadow-cyan/30 group-hover:shadow-cyan/50 transition-shadow duration-300">
              <LuZap className="w-7 h-7 text-primary-foreground" />
            </div> */}
            <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-cyan to-emerald blur-xl opacity-50 group-hover:opacity-70 transition-opacity duration-300" />
          </div>
          <span className="text-3xl font-extrabold tracking-tight  text-black dark:text-white">
            Flox
            <span className="inline-block text-gradient relative">
              pad
          
            </span>
          </span>
        </Link>

        {/* <h1 className="text-4xl lg:text-5xl font-bold mb-6 leading-tight text-black dark:text-white">
          Welcome back to <span className="text-gradient">FloxPad</span>
        </h1> */}
        <p className="text-lg text-muted-foreground leading-relaxed">
         Combines human problem-solving with AI speed to deliver rapid, intelligent, and cost-efficient delivery and testing solutions—cutting timelines from months to weeks or even days.
        </p>

        <div className="mt-12 glass-card p-6 text-left">
          <div className="flex items-center gap-4 mb-4">
            {/* <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-cyan/20 to-emerald/20 flex items-center justify-center">
              <LuZap className="w-5 h-5 text-primary" />
            </div> */}
            <div>
              <p className="font-semibold  text-black dark:text-white">
                Enterprise-Grade Security
              </p>
            </div>
          </div>
          <p className="text-sm text-muted-foreground">
            Your data is protected with end-to-end encryption and advanced
            security protocols.
          </p>
        </div>
      </div>
    </div>
  );
}
